module.exports = __webpack_public_path__ + "static/img/Bro-sel.749e2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/images/icon/Bro-sel.png
// module id = OwnP
// module chunks = 110